module.exports = __webpack_public_path__ + "static/thpcminthamper-1f27ce62763879389f1ef2f5b262b1d9.jpeg";